// browserUUID 生成浏览器唯一标识

export default function () {
	const key = 'XITO_BROWSER_UUID',
		  timeLength = 15552000;	// 180天(半年)
	let uuid = '',
		arrCookie = document.cookie.split("; ")
					.filter(v => v.slice(0, key.length) === key);
	// 存在UUID
	if (arrCookie.length) {
		uuid = arrCookie[0].split('=')[1] || '';
	}
	// 不存在生成一个
	else {
		let time = Date.parse(new Date()),
			data = (String(time) + 'ABCDEFGHIJKLMNOPQRSTUVWXYZ').split('');
		for (let i = 0, length = data.length; i < length; i++) {
			if (length) {
				let index = Math.floor(Math.random() * length);
				uuid += data[index];
				data.splice(index, 1);
				length--;
				i--;
			}
		}
		uuid = uuid.slice(0, 8) + '-'
			   + uuid.slice(8, 12) + '-'
			   + uuid.slice(12, 16) + '-'
			   + uuid.slice(16, 20) + '-'
			   + uuid.slice(20, uuid.length - 7);
		uuid = (Math.random() < 0.5) 
				? (time + '-' + uuid) 
				: (uuid + '-' + time);
		// 保存到cookie
		let expireTime = new Date();
		expireTime.setTime(expireTime.getTime() + timeLength);
		let date = ";expires=" + expireTime.toGMTString();
		document.cookie = key + '=' + uuid + date;
	}
	return uuid;
}






// class BrowserUUID{
// 	constructor() {
// 	    this.key = 'XITO_BROWSER_UUID';
// 	    this.timeLength = 15552000;	// 180天(半年)
// 		this.uuid = '';
// 		this.getData();
// 	}
// 	setData() {
// 		let uuid = '',
// 			time = Date.parse(new Date()),
// 			data = (String(time) + 'ABCDEFGHIJKLMNOPQRSTUVWXYZ').split('');
// 		for (let i = 0, length = data.length; i < length; i++) {
// 			if (length) {
// 				let index = Math.floor(Math.random() * length);
// 				uuid += data[index];
// 				data.splice(index, 1);
// 				length--;
// 				i--;
// 			}
// 		}
// 		uuid = uuid.slice(0, 8) + '-'
// 			   + uuid.slice(8, 12) + '-'
// 			   + uuid.slice(12, 16) + '-'
// 			   + uuid.slice(16, 20) + '-'
// 			   + uuid.slice(20, uuid.length - 7);
// 		uuid = (Math.random() < 0.5) 
// 				? (time + '-' + uuid) 
// 				: (uuid + '-' + time);
// 		// 保存到cookie
// 		let expireTime = new Date();
// 		expireTime.setTime(expireTime.getTime() + this.timeLength);
// 		let date = ";expires=" + expireTime.toGMTString();
// 		document.cookie = this.key + '=' + uuid + date;
// 		return uuid;
// 	}
// 	getData() {
// 		let uuid = '',
// 			arrCookie = document.cookie.split("; ")
// 						.filter(v => v.slice(0, this.key.length) === this.key);
// 		// 存在UUID
// 		if (arrCookie.length) {
// 			uuid = arrCookie[0].split('=')[1] || '';
// 		}
// 		// 不存在生成一个
// 		else {
// 			uuid = this.setData();
// 		}
// 		this.uuid = uuid;
// 		return uuid;
// 	}
// }

// export default new BrowserUUID

// export default {
// 	key: 'XITO_BROWSER_UUID',
// 	timeLength: 604800,		// 7天
// 	create() {
// 		let uuid = '',
// 			time = Date.parse(new Date()),
// 			data = (String(time) + 'ABCDEFGHIJKLMNOPQRSTUVWXYZ').split('');
// 		for (let i = 0, length = data.length; i < length; i++) {
// 			if (length) {
// 				let index = Math.floor(Math.random() * length);
// 				uuid += data[index];
// 				data.splice(index, 1);
// 				length--;
// 				i--;
// 			}
// 		}
// 		uuid = uuid.slice(0, 8) + '-'
// 			   + uuid.slice(8, 12) + '-'
// 			   + uuid.slice(12, 16) + '-'
// 			   + uuid.slice(16, 20) + '-'
// 			   + uuid.slice(20, uuid.length - 7);
// 		uuid = (Math.random() < 0.5) ? (time + '-' + uuid) : (uuid + '-' + time);
// 		return uuid;
// 	},
// 	setCookie(uuid) {
// 		let expireTime = new Date();
// 		expireTime.setTime(expireTime.getTime() + this.timeLength);
// 		let date = ";expires=" + expireTime.toGMTString();
// 		document.cookie = this.key + '=' + uuid + date;
// 		return uuid;
// 	},
// 	getCookie() {
// 		let uuid = '',
// 			arrCookie = document.cookie.split("; ");
// 		arrCookie = arrCookie.filter(v => v.slice(0, this.key.length) === this.key);
// 		if (arrCookie.length) {
// 			uuid = arrCookie[0].split('=')[1] || '';
// 		}
// 		return uuid;
// 	},
// 	getData() {
// 		// 不存在生成一个并保存在cookie里面
// 		let uuid = this.getCookie() || this.create();
// 		this.setCookie(uuid);
// 		return uuid;
// 	}
// }